import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ImageModule, LinkModule } from '@streamamg/components-lib';
import { CarouselLibModule } from '@streamamg/carousel-lib';
import { FooterComponent } from './footer.component';
import { SharedModule } from '../../shared/shared.module';
import { TeamBoxComponent } from './components/team-box/team-box.component';


@NgModule({
  declarations: [
    FooterComponent,
    TeamBoxComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    CarouselLibModule,
    ImageModule,
    RouterModule,
    LinkModule,
  ],
  exports: [
    FooterComponent,
  ],
})
export class FooterModule {
}
